import { useMemo } from 'react'

import { PlusIcon } from '@radix-ui/react-icons'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { createColumnHelper } from '@tanstack/react-table'

import { PageCard, PageLayout } from '@/components/ui/page'
import {
	CellText,
	CellTextDate,
	DataTable,
	useDataTable,
} from '@/components/ui/table/data-table'

import { authzTeamList } from '@/features/authz/api'
import type { IAuthzTeam } from '@/features/authz/type'

export const Route = createFileRoute('/_app/settings/team/')({
	component: Component,
})

function Component() {
	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/settings', 'Pengaturan'],
					['/settings/team', 'Team'],
				]}
			/>
			<PageLayout.ContentSingleColumn>
				<PageCard.Root>
					<PageCard.Header
						title="Daftar akses dan grup"
						actions={
							<PageCard.HeaderAction asChild>
								<Link from={Route.fullPath} to="/settings/team/create">
									<PlusIcon /> Tambah
								</Link>
							</PageCard.HeaderAction>
						}
					/>
					<AccessGroupTable />
				</PageCard.Root>
			</PageLayout.ContentSingleColumn>
		</PageLayout.Root>
	)
}

function AccessGroupTable() {
	const navigate = Route.useNavigate()
	const { data, isLoading } = useQuery(authzTeamList.qry())
	const columns = useColumns()
	const { table } = useDataTable({
		columns,
		data: data?.teams ?? [],
	})

	return (
		<DataTable
			table={table}
			columns={columns}
			isLoading={isLoading}
			onRowClick={(r) =>
				navigate({
					to: '/settings/team/$id/edit',
					params: { id: r.original.id },
				})
			}
		/>
	)
}

const columnHelper = createColumnHelper<IAuthzTeam>()
const useColumns = () => {
	const columns = useMemo(() => {
		return [
			columnHelper.accessor('name', {
				header: () => 'Name',
				cell: ({ row }) => <CellText text={row.original.name} />,
			}),
			columnHelper.accessor('scopes', {
				header: () => 'Scopes',
				cell: ({ row }) => (
					<CellText text={`${row.original.scopes.length} Scopes`} />
				),
			}),
			columnHelper.accessor('createdAt', {
				header: () => 'Created At',
				cell: ({ row }) => <CellTextDate date={row.original.createdAt} />,
			}),
			columnHelper.accessor('updatedAt', {
				header: () => 'Updated At',
				cell: ({ row }) => <CellTextDate date={row.original.updatedAt} />,
			}),
		]
	}, [])

	return columns
}
